import { toggleMessageLoader, addSystemMessage, initBotInstance, addBotMessage } from "#scripts/dialog/dialog_messages.js";
import { getConfig, isMobile } from "#scripts/general_functions.js";
import dayjs from "dayjs";
import { setAccordian } from "#scripts/accordian.js";
import kariavatar from "#scripts/kariavatar";
import language from "#scripts/translation";

export const setChatFocus = (bg = true, buttons = true) => {
	const chatbotSearch = document.querySelector(".chatbot-search");
	const avatarContainer = document.querySelector(".dialog__avatarcontainer");
	if (bg === true) {
		chatbotSearch?.classList.add("transform-bg");
		avatarContainer?.classList.add("dialogongoing");
	} else {
		chatbotSearch?.classList.remove("transform-bg");
	}
	if (buttons === true) {
		chatbotSearch?.classList.add("show-actions");
	} else {
		chatbotSearch?.classList.remove("show-actions");
	}
};

export const scrollToBottom = () => {
	const chatbotContainer = document.getElementById("chatbot__container");
	if (chatbotContainer?.classList.contains("chatbot__mobile-show")) {
		const element = document.getElementById("chatbot__messagearea");
		if (element) {
			// element.scrollTop = element.scrollHeight;
			element.scrollTo({
				top: element.scrollHeight,
				behavior: "smooth",
			});
		}
		// window.scrollTo(0, document.body.scrollHeight);
		window.scrollTo({
			top: document.body.scrollHeight,
			behavior: "smooth",
		});

		document.body.classList.add("overflow-hidden");
		document.querySelector("main")?.classList.add("d-none");
		document.querySelector("footer")?.classList.add("d-none");
		document.querySelector(".navbar")?.classList.add("d-none");
		document.querySelector(".warnings")?.classList.add("d-none");
	} else {
		const chatContainer = document.querySelector(".chatbot-search--container");
		if (chatContainer) {
			// chatContainer.scrollTop = chatContainer.scrollHeight;
			chatContainer.scrollTo({
				top: chatContainer.scrollHeight,
				behavior: "smooth",
			});
		}
	}
};

export const printConversation = () => {
	const currentConversation = sessionStorage.getItem("conversationHtml");
	const dialogWindow = document.getElementById("kari__dialog__window");
	if (currentConversation && dialogWindow) {
		dialogWindow.innerHTML = `<div class='dialog__history'>${currentConversation}</div>`;
	}
	setAccordian();
};

export const downloadConversation = async () => {
	const body = { 
		command: "DOWNLOAD", 
		format: 'json' 
	};

	if (sessionStorage.getItem("chat_sessionid") && sessionStorage.getItem("chat_sessionid").length > 0) {
		body.conversation_id = sessionStorage.getItem("chat_sessionid");
	}

	const response = await fetch("//007prokom.boost.ai/api/chat/v2", {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(body)
	});

	if (!response.ok) {
		const text = await response.text();
		throw new Error(`Download error ${response.status}: ${text}`);
	}
	return response.blob();
};

export const deleteConversation = () => {
	window.scrollTo(0, 0);

	const dialogWindow = document.getElementById("kari__dialog__window");
	if (dialogWindow) dialogWindow.innerHTML = "";

	toggleMessageLoader();
	addSystemMessage(language("DELETE_ALL_TRACKS"));

	setTimeout(() => {
		document.querySelectorAll(".removewhendone").forEach(el => el.remove());

		addSystemMessage(language("CONVERSATION_DELETED"));
		addSystemMessage("", "seperator");

		sessionStorage.removeItem("conversation");
		sessionStorage.removeItem("chat_sessionid");
		sessionStorage.removeItem("conversationHtml");

		initBotInstance();
	}, 1000);

	const body = { command: "DELETE" };

	if (sessionStorage.getItem("chat_sessionid") && sessionStorage.getItem("chat_sessionid").length > 0) {
		body.conversation_id = sessionStorage.getItem("chat_sessionid");
	}

	fetch("//007prokom.boost.ai/api/chat/v2", {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(body),
	});
};

export const restartConversation = () => {
	window.scrollTo(0, 0);

	toggleMessageLoader();

	setTimeout(() => {
		document.querySelectorAll(".removewhendone").forEach(el => el.remove());

		addSystemMessage("", "seperator");

		sessionStorage.removeItem("conversation");
		sessionStorage.removeItem("chat_sessionid");
		sessionStorage.removeItem("conversationHtml");

		initBotInstance();
	}, 500);
};

export const toggleChatVisibility = (state = true) => {
	const config = getConfig();
	const convHtml = sessionStorage.getItem("conversationHtml") || "";

	const startKariChat = () => {
		const dialogWindow = document.getElementById("kari__dialog__window");
		const chatbotContainer = document.querySelector(".chatbot__container");
		if (isMobile()) {
			addSystemMessage(language("INTRO_QUESTION"), "html", true, "dialog__start first");
			chatbotContainer?.classList.add("chatbot__mobile");
		} else {
			let msgnr = 0;
			const skip = Number.parseInt(window.serverdata.configMeta.aim.kariSkipStartMessages);
			const fromKari = JSON.parse(sessionStorage.getItem("chat_initialresponse"));
			if (Array.isArray(fromKari)) {
				fromKari.forEach((b) => {
					const msgNrClass = msgnr === 0 ? "dialog__start first" : "dialog__start";
					if (skip - 1 !== msgnr) {
						addSystemMessage(b, b.type, true, msgNrClass);
					}
					msgnr++;
				});
			}
		}
	};

	const dialogInput = document.querySelector(".dialog__input");
	const chatbotSearch = document.querySelector(".chatbot-search");
	const avatarContainer = document.querySelector(".dialog__avatarcontainer");

	if (state === true) {
		const dialogWindow = document.getElementById("kari__dialog__window");
		if (dialogWindow) dialogWindow.innerHTML = "";

		if (config.template !== "frontpage") {
			chatbotSearch?.classList.add("condensed", "continue");
			avatarContainer?.classList.add("dialog__avatarcontainer-condensed", "dialog__avatarcontainer-continue");
			const kari = kariavatar();
			if (window?.kariAnimator?.waveSvgHtml !== undefined) {
				if (avatarContainer) avatarContainer.innerHTML = window.kariAnimator.waveSvgHtml;
			} else {
				if (avatarContainer) avatarContainer.innerHTML = kari;
			}
			setChatFocus(true, false);
			if (convHtml.length > 0) {
				if (dialogInput) dialogInput.setAttribute("placeholder", language("CONTINIUE_CONVERSATION"));
			} else {
				if (dialogInput) dialogInput.setAttribute("placeholder", language("START_OR_SEARCH"));
			}
			window.scrollTo(0, 0);
		} else if (convHtml && (convHtml.match(/class=["']dialog__fromkari["']/g) || []).length > 3) {
			chatbotSearch?.classList.add("continue");
			avatarContainer?.classList.add("dialog__avatarcontainer-continue");
			setChatFocus(false, false);

			if (dialogInput) dialogInput.setAttribute("placeholder", language("CONTINIUE_CONVERSATION"));
			window.scrollTo(0, 0);
		} else if (convHtml && (convHtml.match(/class=["']dialog__fromkari["']/g) || []).length === 3) {
			setChatFocus(false, false);
			startKariChat();
		} else {
			setChatFocus(false, false);
			const dialogWindow = document.getElementById("kari__dialog__window");
			if (dialogWindow && !dialogWindow.querySelector(".dialog__fromkari.dialog__start")) {
				startKariChat();
			}
		}
	} else {
		setChatFocus();
		chatbotSearch?.classList.remove("condensed", "continue");
		avatarContainer?.classList.remove("dialog__avatarcontainer-condensed", "dialog__avatarcontainer-continue");
		if (dialogInput) dialogInput.setAttribute("placeholder", "");
		printConversation();
		scrollToBottom();
	}
};

export const addFeedbackButtons = (obj) => {
	const dialogWindow = document.getElementById("kari__dialog__window");
	if (dialogWindow) {
		const feedbackHtml = addBotMessage({
			type: "vote",
			html: `
        <div class='dialog__feedback__buttons text-right'>
            <button data-id="${obj.response.id}" data-value="positive" class="btn btn-light dialog__feedback__button dialog__feedback__button--positive" aria-label="Liker"><span class="material-icons-outlined notranslate">thumb_up</span></button>
            <button data-id="${obj.response.id}" data-value="negative" class="btn btn-light dialog__feedback__button dialog__feedback__button--negative" aria-label="Missliker"><span class="material-icons-outlined notranslate">thumb_down</span></button>
        </div>`,
		});
		dialogWindow.insertAdjacentHTML("beforeend", feedbackHtml);
	}
	scrollToBottom();
};

export const clearOnInactivity = () => {
	if (Number.parseInt(sessionStorage.getItem("lastmessage")) < dayjs().subtract(1, "minute").valueOf()) {
		const dialogWindow = document.getElementById("kari__dialog__window");
		if (dialogWindow) dialogWindow.innerHTML = "";

		toggleMessageLoader();
		addSystemMessage(language("INACTIVE_DELETION"));

		document.querySelectorAll(".removewhendone").forEach(el => el.remove());

		addSystemMessage("", "seperator");

		sessionStorage.removeItem("conversation");
		sessionStorage.removeItem("chat_sessionid");
		sessionStorage.removeItem("conversationHtml");

		initBotInstance();
	}
};

export const extractMetaValue = (metaobj, key) => {
	if (typeof metaobj !== "object") return false;
	const matches = [];
	Object.values(metaobj).forEach((b) => {
		if (b.name === key) {
			matches.push(b.value);
		}
	});
	if (matches.length === 1) return matches[0];
	return matches;
}; 
